import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { USE_ALL_HANDLERS } from 'config/featureFlags'
import Button from 'components/common/Button'
import Select from 'components/common/Select'
import Handlers, { HandlerOption } from 'types/Handlers'
import c from './HandlerSelect.module.scss'

const getTogglerButtonClasses = (isActive: boolean): string => {
  let result = c.togglerButton
  if (isActive) result += ` ${c.togglerButtonActive}`
  return result
}

interface HandlerChangerProps {
  handler: HandlerOption
  handlerOptions: HandlerOption[]
  onHandlerChange: (newHandler: HandlerOption) => void
}

function HandlerSelect({
  handler,
  handlerOptions,
  onHandlerChange,
}: HandlerChangerProps) {
  const { t } = useTranslation()

  const handleSelectChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      const newHandler = handlerOptions.find((h) => h.value === e.target.value)
      if (newHandler === undefined) return
      onHandlerChange(newHandler)
    },
    [onHandlerChange],
  )

  const handleTogglerButtonClick = useCallback(
    (handlerSlug: `${Handlers}`) => () => {
      const newHandler = handlerOptions.find((h) => h.value === handlerSlug)
      if (newHandler === undefined) return
      onHandlerChange(newHandler)
    },
    [onHandlerChange],
  )

  if (USE_ALL_HANDLERS) {
    return (
      <Select
        className={c.select}
        option={handler}
        options={handlerOptions}
        onChange={handleSelectChange}
      />
    )
  }

  return (
    <div className={c.toggler}>
      <Button
        className={getTogglerButtonClasses(
          handler.value === Handlers.THOMAS_JEFFERSON,
        )}
        onClick={handleTogglerButtonClick(Handlers.THOMAS_JEFFERSON)}
      >
        {t('general.handlers.standard')}
      </Button>
      <Button
        className={getTogglerButtonClasses(
          handler.value === Handlers.GEORGE_WASHINGTON,
        )}
        onClick={handleTogglerButtonClick(Handlers.GEORGE_WASHINGTON)}
      >
        {t('general.handlers.face')} (new)
      </Button>
    </div>
  )
}

export default HandlerSelect
